module.exports = __webpack_public_path__ + "r-v3/img/hand_white.e9aeee80.svg";